import './ViewportLayout.css';
import { observer } from 'mobx-react-lite';
import TopNavBar from './TopNavBar';
import GlobalProgressBar from './GlobalProgressBar';
import GameContainerView from './GameContainerView';
import ModalDialog from './modalDialogs/ModalDialogView';

const ViewportLayout = observer(() => {
    return (
        <div className="viewport-container">
            <TopNavBar />
            <GlobalProgressBar>
                <GameContainerView />
            </GlobalProgressBar>
            <ModalDialog />
        </div>
    );
});

export default ViewportLayout;